import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { clientIdGuard } from '../guards/client-id/client-id.guard';

export const tableFormRoutes: Routes = [
  {
    path: 'tables/clients/edit',
    loadComponent: () =>
      import('../components/tables/client-form/client-form.component').then(
        (m) => m.ClientFormComponent
      ),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/data-sources/edit',
    loadComponent: () =>
      import(
        '../components/tables/data-source-form/data-source-form.component'
      ).then((m) => m.DataSourceFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/data-internal-use/edit',
    loadComponent: () =>
      import(
        '../components/tables/data-internal-use-form/data-internal-use-form.component'
      ).then((m) => m.DataInternalUseFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/product-purchased/edit',
    loadComponent: () =>
      import(
        '../components/tables/product-purchased-form/product-purchased-form.component'
      ).then((m) => m.ProductPurchaseFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/chargebacks/edit',
    loadComponent: () =>
      import(
        '../components/tables/chargebacks-form/chargebacks-form.component'
      ).then((m) => m.ChargebacksFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/merchants/edit',
    loadComponent: () =>
      import('../components/tables/merchant-form/merchant-form.component').then(
        (m) => m.MerchantFormComponent
      ),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/merchant-services/edit',
    loadComponent: () =>
      import(
        '../components/tables/merchant-services-form/merchant-services-form.component'
      ).then((m) => m.MerchantServicesFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/requests/edit',
    loadComponent: () =>
      import('../components/tables/requests-form/requests-form.component').then(
        (m) => m.RequestsFormComponent
      ),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/descriptors/edit',
    loadComponent: () =>
      import(
        '../components/tables/descriptor-form/descriptor-form.component'
      ).then((m) => m.DescriptorFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/billing-client-service/edit',
    loadComponent: () =>
      import(
        '../components/tables/billing-client-services-form/billing-client-services-form.component'
      ).then((m) => m.BillingClientServicesFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/alerts-action-queue/edit',
    loadComponent: () =>
      import(
        '../components/tables/alerts-action-queue-form/alerts-action-queue-form.component'
      ).then((m) => m.AlertsActionQueueFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/client-trx-data/edit',
    loadComponent: () =>
      import(
        '../components/tables/client-trx-data-form/client-trx-data-form.component'
      ).then((m) => m.ClientTrxDataFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/merchant-data-sources/edit',
    loadComponent: () =>
      import(
        '../components/tables/merchant-data-source-form/merchant-data-source-form.component'
      ).then((m) => m.MerchantDataSourceFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/titan-runner/edit',
    loadComponent: () =>
      import(
        '../components/titan/titan-runner-form/titan-runner-form.component'
      ).then((m) => m.TitanRunnerFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/titan-source/edit',
    loadComponent: () =>
      import(
        '../components/titan/titan-source-form/titan-source-form.component'
      ).then((m) => m.TitanSourceFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/titan-process/edit',
    loadComponent: () =>
      import(
        '../components/titan/titan-process-form/titan-process-form.component'
      ).then((m) => m.TitanProcessFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
  {
    path: 'tables/titan-action/edit',
    loadComponent: () =>
      import(
        '../components/titan/titan-action-form/titan-action-form.component'
      ).then((m) => m.TitanActionFormComponent),
    canActivate: [authGuard, clientIdGuard],
  },
];
